module.exports = __webpack_public_path__ + "static/media/PHL.74e32603.svg";